import { render, staticRenderFns } from "./LdEmailNylasMigrationBanner.vue?vue&type=template&id=30963cda"
import script from "./LdEmailNylasMigrationBanner.vue?vue&type=script&lang=js"
export * from "./LdEmailNylasMigrationBanner.vue?vue&type=script&lang=js"
import style0 from "./LdEmailNylasMigrationBanner.vue?vue&type=style&index=0&id=30963cda&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports